/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Error_ToastInputs */

const en_error_toast = /** @type {(inputs: Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`An error occurred: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "An error occurred: {message}" |
*
* @param {Error_ToastInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_toast = /** @type {((inputs: Error_ToastInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_ToastInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_toast(inputs)
});